module.exports = __webpack_public_path__ + "img/bg_icon2.a1b37207.png";